<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color} stroke-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 17 18">
    <path
      d="M16.4299 8.36426C16.3128 6.69907 15.6643 5.08229 14.5983 3.80758L16.7747 1.63574L16.1673 1L13.9973 3.16539C10.9795 0.277128 6.16494 0.351351 3.23256 3.34288C0.312826 6.3215 0.192621 11.0783 2.9447 14.2021L0.777832 16.3643L1.38519 17L3.55838 14.8282C6.62046 17.6131 11.2737 17.4808 14.1808 14.5119C15.4999 13.1662 16.297 11.3848 16.4299 9.49052L16.4457 9.28076V8.57079L16.4299 8.36426ZM15.6011 8.929C15.6011 9.84227 15.4334 10.7297 15.0981 11.5752C14.7502 12.4466 14.2409 13.2307 13.5829 13.902C12.9249 14.5732 12.1562 15.0928 11.3021 15.4478C10.4765 15.7898 9.60345 15.9609 8.71457 15.9609H8.70508C7.81302 15.9609 6.93995 15.7866 6.11433 15.4445C5.40259 15.1509 4.74778 14.7378 4.1689 14.2215L13.9878 4.41751C14.456 4.98548 14.8292 5.61154 15.095 6.28278C15.4303 7.12505 15.6011 8.01573 15.5979 8.929H15.6011ZM13.3899 3.77531L3.55205 13.5986C3.03011 12.9984 2.61571 12.3207 2.31836 11.5785C1.98305 10.7362 1.81223 9.8455 1.8154 8.93223C1.8154 8.02219 1.98305 7.1315 2.31836 6.286C2.66316 5.41468 3.17245 4.6305 3.83359 3.95926C4.49155 3.28802 5.26024 2.76845 6.11433 2.41347C6.93995 2.0714 7.80986 1.89714 8.70191 1.89714C8.70508 1.89714 8.7114 1.89714 8.71457 1.89714C9.60978 1.89714 10.4797 2.0714 11.3021 2.41025C12.0677 2.7265 12.7699 3.18475 13.3899 3.77209V3.77531Z"
      :class="colorClass"
      stroke-width="0.3"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
